import React, { FC } from 'react';
import classNames from 'classnames';

type Props = {
  value: string;
  hasError: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const DecisionUploadYearField: FC<Props> = ({
  value,
  hasError,
  onChange,
}) => {
  return (
    <input
      id="year"
      value={value}
      className={classNames(hasError && 'is-invalid-input')}
      name="year"
      type="text"
      placeholder="année"
      onChange={onChange}
    />
  );
};
